import { render, staticRenderFns } from "./UserEmailLogs.vue?vue&type=template&id=65a4bf7c&"
import script from "./UserEmailLogs.vue?vue&type=script&lang=js&"
export * from "./UserEmailLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports